import { render } from "./InternalProductMainInformationPage.vue?vue&type=template&id=76a28761"
import script from "./InternalProductMainInformationPage.vue?vue&type=script&lang=js"
export * from "./InternalProductMainInformationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__